import ManagerApiFeatureFlag from "../../utils/ManagerApiFeatureFlag";
import AxiosService from "../axios-service/AxiosService";
import { Organization } from "../models/Organization";
import Storage from "../storage-service/Storage";

const MANAGER_BFF_HOST = process.env.REACT_APP_MANAGER_BFF_URL;
const MANAGER_API = process.env.REACT_APP_MANAGER_API;

export class OrganizationService {
    static async getUserOrganizations(): Promise<Organization[]> {
        const token = Storage.get("userToken");
        const options = {
            headers: {
                Authorization: `Bearer ${token}`,
                ...ManagerApiFeatureFlag.getNewManagerApiStorageConfig()
            }
        };
        // const url = `${MANAGER_BFF_HOST}/v1/mini-apps/p/users/organizations`;
        const url = `${MANAGER_API}/users/me/organizations`;
        const response = await AxiosService.httpGet(url, options);

        return response.data;
    }

    static async getAllOrganizations(): Promise<Organization[]> {
        const token = Storage.get("userToken");
        const options = {
            headers: {
                Authorization: `Bearer ${token}`,
                ...ManagerApiFeatureFlag.getNewManagerApiStorageConfig()
            }
        };
        const url = `${MANAGER_BFF_HOST}/v1/mini-apps/p/organizations`;
        // const url = `${MANAGER_API}/users/me/organizations`
        const response = await AxiosService.httpGet(url, options);

        return response.data;
    }
}
